import CTACard from '../../../components/cta-card'
import { ROUTES } from '../../../constants'

export default function CTACards() {
  return (
    <div className='cardsContainer'>
      <div className='wrapper flex justifyBetween'>
        <CTACard
          href={ROUTES.Search}
          imgSrc='/images/cars-outside.jpg'
          alt='cars outside'
          heading='Buy a vehicle'
          description='Search listings'
          width='810'
          height='430'
        />
        <CTACard
          href={ROUTES.GetVerified}
          imgSrc='/images/person-holding-phone.png'
          alt='person holding smartphone'
          heading='Become a verified user'
          description='Start verification'
          width='810'
          height='430'
        />
      </div>

      <style jsx>{`
        .cardsContainer {
          width: 100%;
          max-width: 166.6rem;
          margin: auto;
        }

        .wrapper {
          flex-wrap: wrap;
          width: 100%;

          :global(.cardContainer) {
            width: calc((100% - 2.9rem) / 2);
          }
        }

        @media (max-width: 1024px) {
          .cardsContainer {
            max-width: 54rem;
          }

          .wrapper {
            flex-direction: column;

            :global(.cardContainer) {
              width: 100%;
              margin: 0 0 1.7rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
